<div class="visit-table-cell-date" style="{{ minWidth ? 'min-width:' +minWidth : ''}}" [formGroup]="parentForm">
  <span *ngIf="!editable" class="label-only">
  {{ isDate(parentForm.get(controlName).value) ? (parentForm.get(controlName).value | date: 'dd-MM-yyyy') : parentForm.get(controlName).value }}
</span>

  <mat-form-field appearance="fill" *ngIf="editable">
    <input #input matInput [matDatepicker]="picker" [formControlName]="controlName" maxlength="10">
    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
  </mat-form-field>
</div>
